export default [
  {
    path: "/B47xeHfe6126d3b6e1186d5ab5ab81iSQWSp",
    children: [
      {
        path: "Nv95pfe99d63513c44de462d0f295xqHkUfB",
        name: "faculty.comments",
        meta: {
          title: `Grades & comments`,
          authRequired: true,
          acc: ["y110838"],
        },
        component: () => import("@/views/faculty-comment/index.vue"),
      },
      {
        path: "L23Ife80e1893fa3c34332cdcad6hjOhwYxW",
        name: "faculty.comment.add",
        meta: {
          title: `Add comment`,
          authRequired: true,
          acc: ["y3399138"],
        },
        component: () => import("@/views/faculty-comment/upload.vue"),
      },
    ],
  },
];
